module.exports = __webpack_public_path__ + "img/Anhui-power.b7954d98.png";